/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: Z4n6NebjkHpR

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  renderPlasmicSlot,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { CopilotCodePrompt } from "../../components/copilot/CopilotCodePrompt"; // plasmic-import: SdMPiPjcB9G/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_data_binding.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicDataQueryCodeEditorLayout.module.css"; // plasmic-import: Z4n6NebjkHpR/css

createPlasmicElementProxy;

export type PlasmicDataQueryCodeEditorLayout__VariantMembers = {
  hidePreview: "hidePreview";
  copilot: "copilot";
};
export type PlasmicDataQueryCodeEditorLayout__VariantsArgs = {
  hidePreview?: SingleBooleanChoiceArg<"hidePreview">;
  copilot?: SingleBooleanChoiceArg<"copilot">;
};
type VariantPropType = keyof PlasmicDataQueryCodeEditorLayout__VariantsArgs;
export const PlasmicDataQueryCodeEditorLayout__VariantProps =
  new Array<VariantPropType>("hidePreview", "copilot");

export type PlasmicDataQueryCodeEditorLayout__ArgsType = {
  codeEditor?: React.ReactNode;
  env?: React.ReactNode;
};
type ArgPropType = keyof PlasmicDataQueryCodeEditorLayout__ArgsType;
export const PlasmicDataQueryCodeEditorLayout__ArgProps =
  new Array<ArgPropType>("codeEditor", "env");

export type PlasmicDataQueryCodeEditorLayout__OverridesType = {
  root?: Flex__<"div">;
  codePanel?: Flex__<"div">;
  text?: Flex__<"div">;
  envPreviewContainer?: Flex__<"div">;
  h4?: Flex__<"h4">;
  copilotCodePrompt?: Flex__<typeof CopilotCodePrompt>;
};

export interface DefaultDataQueryCodeEditorLayoutProps {
  codeEditor?: React.ReactNode;
  env?: React.ReactNode;
  hidePreview?: SingleBooleanChoiceArg<"hidePreview">;
  copilot?: SingleBooleanChoiceArg<"copilot">;
  className?: string;
}

const $$ = {};

function PlasmicDataQueryCodeEditorLayout__RenderFunc(props: {
  variants: PlasmicDataQueryCodeEditorLayout__VariantsArgs;
  args: PlasmicDataQueryCodeEditorLayout__ArgsType;
  overrides: PlasmicDataQueryCodeEditorLayout__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "hidePreview",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.hidePreview,
      },
      {
        path: "copilot",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.copilot,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_w2GXN278dkQ2gQTVQnPehW",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        { [sty.rootcopilot]: hasVariant($state, "copilot", "copilot") }
      )}
    >
      <div
        data-plasmic-name={"codePanel"}
        data-plasmic-override={overrides.codePanel}
        className={classNames("all", sty.codePanel, {
          [sty.codePanelcopilot]: hasVariant($state, "copilot", "copilot"),
          [sty.codePanelhidePreview]: hasVariant(
            $state,
            "hidePreview",
            "hidePreview"
          ),
        })}
      >
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames("all", "__wab_text", sty.text, {
            [sty.textcopilot]: hasVariant($state, "copilot", "copilot"),
            [sty.texthidePreview]: hasVariant(
              $state,
              "hidePreview",
              "hidePreview"
            ),
          })}
        >
          {
            "Write your custom code below. Available variables are listed in the data context section."
          }
        </div>
        <div
          className={classNames("all", sty.freeBox__lslrH, {
            [sty.freeBoxcopilot__lslrHtz8OZ]: hasVariant(
              $state,
              "copilot",
              "copilot"
            ),
          })}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <div className={classNames("all", "__wab_text", sty.text__ibXjf)}>
                {"Monaco Editor here"}
              </div>
            ),
            value: args.codeEditor,
          })}
        </div>
      </div>
      <div
        data-plasmic-name={"envPreviewContainer"}
        data-plasmic-override={overrides.envPreviewContainer}
        className={classNames("all", sty.envPreviewContainer, {
          [sty.envPreviewContainercopilot]: hasVariant(
            $state,
            "copilot",
            "copilot"
          ),
          [sty.envPreviewContainerhidePreview]: hasVariant(
            $state,
            "hidePreview",
            "hidePreview"
          ),
        })}
      >
        <div
          className={classNames("all", sty.freeBox__cUvYc, {
            [sty.freeBoxcopilot__cUvYctz8OZ]: hasVariant(
              $state,
              "copilot",
              "copilot"
            ),
          })}
        >
          <h4
            data-plasmic-name={"h4"}
            data-plasmic-override={overrides.h4}
            className={classNames(
              "all",
              "h4",
              "h4__w2GXN",
              "__wab_text",
              sty.h4,
              {
                [sty.h4copilot]: hasVariant($state, "copilot", "copilot"),
                [sty.h4hidePreview]: hasVariant(
                  $state,
                  "hidePreview",
                  "hidePreview"
                ),
              }
            )}
          >
            {"Data Context"}
          </h4>
          {(hasVariant($state, "copilot", "copilot") ? true : false) ? (
            <CopilotCodePrompt
              data-plasmic-name={"copilotCodePrompt"}
              data-plasmic-override={overrides.copilotCodePrompt}
              className={classNames("__wab_instance", sty.copilotCodePrompt, {
                [sty.copilotCodePromptcopilot]: hasVariant(
                  $state,
                  "copilot",
                  "copilot"
                ),
              })}
            />
          ) : null}
        </div>
        <div
          className={classNames("all", sty.freeBox__vjwQ, {
            [sty.freeBoxcopilot__vjwQTz8OZ]: hasVariant(
              $state,
              "copilot",
              "copilot"
            ),
          })}
        >
          {renderPlasmicSlot({
            defaultContents: (
              <div
                className={classNames("all", "__wab_text", sty.text___2Eu4D)}
              >
                {"Env preview here..."}
              </div>
            ),
            value: args.env,
          })}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "codePanel",
    "text",
    "envPreviewContainer",
    "h4",
    "copilotCodePrompt",
  ],
  codePanel: ["codePanel", "text"],
  text: ["text"],
  envPreviewContainer: ["envPreviewContainer", "h4", "copilotCodePrompt"],
  h4: ["h4"],
  copilotCodePrompt: ["copilotCodePrompt"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  codePanel: "div";
  text: "div";
  envPreviewContainer: "div";
  h4: "h4";
  copilotCodePrompt: typeof CopilotCodePrompt;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDataQueryCodeEditorLayout__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDataQueryCodeEditorLayout__VariantsArgs;
    args?: PlasmicDataQueryCodeEditorLayout__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicDataQueryCodeEditorLayout__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicDataQueryCodeEditorLayout__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDataQueryCodeEditorLayout__ArgProps,
          internalVariantPropNames:
            PlasmicDataQueryCodeEditorLayout__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicDataQueryCodeEditorLayout__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDataQueryCodeEditorLayout";
  } else {
    func.displayName = `PlasmicDataQueryCodeEditorLayout.${nodeName}`;
  }
  return func;
}

export const PlasmicDataQueryCodeEditorLayout = Object.assign(
  // Top-level PlasmicDataQueryCodeEditorLayout renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    codePanel: makeNodeComponent("codePanel"),
    text: makeNodeComponent("text"),
    envPreviewContainer: makeNodeComponent("envPreviewContainer"),
    h4: makeNodeComponent("h4"),
    copilotCodePrompt: makeNodeComponent("copilotCodePrompt"),

    // Metadata about props expected for PlasmicDataQueryCodeEditorLayout
    internalVariantProps: PlasmicDataQueryCodeEditorLayout__VariantProps,
    internalArgProps: PlasmicDataQueryCodeEditorLayout__ArgProps,
  }
);

export default PlasmicDataQueryCodeEditorLayout;
/* prettier-ignore-end */
